import React, { useState, useEffect } from "react";
import { useImage } from "../../../context/ImageContext";
import { listFileNamesFromS3, generatePresignedUrl, readFileFromS3 } from "../../../config/aws";
import { USER_NAME } from "../../../constant";

const data = [
  {
    src: "https://storage.googleapis.com/a1aa/image/kMCPnbj6sJ9-_7EgC4oL8sU-T_ury_A68atePtEjto8.jpg",
    alt: "A minimalist room with a vase and a curved sofa"
  },
  {
    src: "https://storage.googleapis.com/a1aa/image/SjBjN3wxSUtIaompEoUZRRnVKuaFKWWmhu33q5-RiKs.jpg",
    alt: "A room with colorful artwork and a blue shelf"
  },
  {
    src: "https://storage.googleapis.com/a1aa/image/28CWQXG-HH18m8VE91VryjSv_fOdngh66V8mGGHHGbg.jpg",
    alt: "A room with two chairs and a small table"
  },
  {
    src: "https://storage.googleapis.com/a1aa/image/kiRaBKGaNAiFlpuOFfTTRJ5r0KfYcV0mjE5XragSfyo.jpg",
    alt: "A room with a black sectional sofa and framed pictures"
  },
  {
    src: "https://storage.googleapis.com/a1aa/image/2g-OC20ppKpedqEJ_TYALHO-qA9QH_kW333a8SH-roI.jpg",
    alt: "A room with a dining table and plants"
  },
  {
    src: "https://storage.googleapis.com/a1aa/image/nxm5Nu1WL4p5iAlx905K4JPELVGosjimmJjJnZKAnwE.jpg",
    alt: "A room with a blue wall and a dresser"
  },
  {
    src: "https://storage.googleapis.com/a1aa/image/0lGr5EygQuVw51RqhIqxJq4acfbg3-ccgohDeB6SQtM.jpg",
    alt: "A modern living room with a sectional sofa"
  },
  {
    src: "https://storage.googleapis.com/a1aa/image/QJaFMArjYDwkXsanDf1z1d2I_8be9g9DNm3vpd0Unm8.jpg",
    alt: "A room with a classic lamp and a chair"
  },
  {
    src: "https://storage.googleapis.com/a1aa/image/kiRaBKGaNAiFlpuOFfTTRJ5r0KfYcV0mjE5XragSfyo.jpg",
    alt: "A room with a black sectional sofa and framed pictures"
  }
];

const SelectProductVeriation = ({ onBack, setIsProductModalOpen, selectedProduct, handleProductSelect, setRefNum, setProductPrompt }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const { activeTab, setSelectedImage } = useImage();
  const [images, setImages] = useState([]);

  const handleImageClick = (index) => {
    setSelectedImageIndex(selectedImageIndex === index ? null : index);
    setRefNum(index);
  };

  const handleProductPrompt = async (imageName) => {
    const jsonData = await readFileFromS3(`USERS/${USER_NAME}/all_products/${selectedProduct}/metadata.json`);
    const prompt = JSON.parse(jsonData).all_prompts[imageName];
    setProductPrompt(prompt);
  }

  const handleUseImage = () => {
    if (selectedImageIndex !== null) {
      if (activeTab === 'bgh') {
        setSelectedImage(images[selectedImageIndex]);
      }
      handleProductSelect({ name: selectedProduct, src: images[selectedImageIndex].src });
      onBack();
      setIsProductModalOpen(false);
      handleProductPrompt(selectedImageIndex !== null ? selectedImageIndex.toString().padStart(3, '0') : null);
    }
  };

  useEffect(() => {
    const fetchImages = async () => {
      const images = await listFileNamesFromS3(`USERS/${USER_NAME}/all_products/${selectedProduct}/user_product_images/wo_bg/`);

      const all_presigned_urls = await Promise.all(images.map(async (image) => ({
        src: await generatePresignedUrl(image),
        alt: image.split('/').pop()
      })));

      setImages(all_presigned_urls);
    };
    fetchImages();
  }, [selectedProduct]);



  return (
    <>
      {/* Header with purple border styling */}
      <div className="flex justify-between items-center border-b border-gray-200 pb-2 mb-4">
        <div className="flex items-center">
          <button onClick={onBack} className="text-xl mr-4 text-purple-600 hover:text-purple-800 transition-colors">
            <i className="fas fa-arrow-left"></i>
          </button>
        </div>
        <div className="flex w-full justify-center border-b-2 border-purple-600">
          <div className="py-2 px-2 font-semibold text-purple-600">
            Select Image Variations
          </div>
        </div>
      </div>
      
      {/* Image Grid */}
      <div className="grid grid-cols-4 gap-4">
        {images.map((image, index) => (
          <div
            key={index}
            className={`relative rounded-lg overflow-hidden group cursor-pointer transition-all duration-300 w-28 h-28 ${selectedImageIndex === index
              ? 'ring-2 ring-purple-500 scale-105'
              : 'hover:ring-2 hover:ring-purple-300'
              }`}
            onClick={() => handleImageClick(index)}
          >
            <img
              src={image.src}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
            />
            {selectedImageIndex === index && (
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 rounded-lg">
                <div className="bg-purple-500 rounded-full w-10 h-10 flex items-center justify-center">
                  <i className="fas fa-check text-white text-base"></i>
                </div>
              </div>
            )}
            {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-2">
              <p className="text-white text-xs truncate">{image.alt}</p>
            </div> */}
          </div>
        ))}
      </div>
      {/* Use Image Button */}
      <div className="mt-6">
        <button
          className={`w-full py-3 rounded-lg text-lg font-medium transition-all duration-300 ${selectedImageIndex !== null
            ? 'bg-purple-500 text-white hover:bg-purple-600 transform hover:scale-[1.02]'
            : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
          disabled={selectedImageIndex === null}
          onClick={handleUseImage}
        >
          Use Selected Image
        </button>
      </div>
    </>
  );
};

export default SelectProductVeriation;
